import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';

import { ModalProps } from '../../types';

import styles from './index.module.scss';

const ConfirmationModal = ({ isOpen, handleCancel, handleContinue }: ModalProps) => {
  const { t } = useTranslation('Disconnect');
  return (
    <CustomStandardModal
      surfaceProps={{ className: styles['planConfirmationModal'] }}
      size="medium"
      isOpen={isOpen}
      header={t('planOffers.modal.header')}
      actions={{
        primary: {
          label: t('button.continuePlanChange'),
          onClick: handleContinue,
        },
        secondary: { label: t('button.cancel'), onClick: handleCancel },
      }}
    >
      <Txt variant="bodyLargeRegular">{t('planOffers.modal.description')}</Txt>
    </CustomStandardModal>
  );
};

export default ConfirmationModal;
